var FavsModule = (function () {
    function FavsModule() {
    }
    return FavsModule;
}());
export { FavsModule };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/favs/favs.module.ts.pre-build-optimizer.js